import Route from '@ember/routing/route';
import { service } from '@ember/service';
import { findRecord } from '@warp-drive/utilities/json-api';
import type { RecommendationExtension as RecommendationModel } from 'tio-data/data/resources/recommendation.ext';
import type { Store } from '@warp-drive/core';

export default class AuthenticatedRepayingStudentDebtRepaymentStrategyFinderResultsRoute extends Route {
  @service declare store: Store;

  async model({ recommendation_id }: { recommendation_id: string }) {
    const { content } = (await this.store.request(
      findRecord<RecommendationModel>('recommendation', recommendation_id)
    )) as { content: { data: RecommendationModel } };
    return content.data;
  }
}
